export default __webpack_public_path__ + "static/media/rightMan.5aedb188.png";